"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerLevel = void 0;
var LoggerLevel = /** @class */ (function () {
    function LoggerLevel(_level, _name, _stream) {
        this.name = _name;
        this.level = _level;
        this.stream = _stream;
    }
    LoggerLevel.prototype.copy = function (stream) {
        return new LoggerLevel(this.level, this.name, stream);
    };
    return LoggerLevel;
}());
exports.LoggerLevel = LoggerLevel;
//# sourceMappingURL=LoggerLevel.js.map